import { call, put, takeLatest } from "redux-saga/effects";
import { khoiApi } from "../../../api/category/khoiApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eKhoiActionTypeIds } from "../../action-types/category/IKhoiActionType";
import { actions } from "../../actions";

export function* khoiSaga(): any {
    yield takeLatest(eKhoiActionTypeIds.LOAD_START, loadWorker)
}
function* loadWorker(): any {
    const res: IBaseRespone = yield call(khoiApi.getAll)
    if (res.is_success) {
        yield put(actions.khoi.loadSuccess(res.data))
    } else {
        yield put(actions.khoi.loadError(res.message))
    }
}